import React from 'react';
import { ChartBar } from '@phosphor-icons/react';

// Analytics API row shape from learn_my_activity_summary metric (single summary row)
interface ActivitySummaryRow {
    totalEnrollments: number;
    completedCount: number;
    inProgressCount: number;
    totalTimeHours: number;
}

interface MyLearningActivityWidgetProps {
    data?: ActivitySummaryRow[] | null;
    loading?: boolean;
    error?: string;
}

export const MyLearningActivityWidget: React.FC<MyLearningActivityWidgetProps> = ({ data, loading, error }) => {
    const rows = Array.isArray(data) ? data : [];
    const stats = rows.length > 0 ? rows[0] : null;

    const totalHours = Number(stats?.totalTimeHours) || 0;
    const totalEnrollments = Number(stats?.totalEnrollments) || 0;
    const completedCount = Number(stats?.completedCount) || 0;
    const inProgressCount = Number(stats?.inProgressCount) || 0;

    return (
        <div className="flex flex-col h-full">
            <div className="px-4 pt-4 pb-4 flex items-center justify-between">
                <span className="text-xs text-gray-400">All Time</span>
            </div>
            <div className="flex-1 overflow-auto px-4 pb-4">
                {loading ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="w-6 h-6 border-3 border-gray-200 border-t-primary rounded-full animate-spin" />
                    </div>
                ) : error ? (
                    <div className="flex items-center justify-center h-full text-red-500 text-sm">{error}</div>
                ) : !stats ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-2">
                        <ChartBar className="w-8 h-8" />
                        <span className="text-sm">No activity data</span>
                    </div>
                ) : (
                    <>
                        <div className="grid grid-cols-2 gap-3 mb-4">
                            <div className="text-center p-3 bg-primary/5 rounded-lg">
                                <div className="text-2xl font-bold text-primary">{totalHours}h</div>
                                <div className="text-[11px] text-gray-500">Total Time</div>
                            </div>
                            <div className="text-center p-3 bg-blue-50 rounded-lg">
                                <div className="text-2xl font-bold text-blue-600">{totalEnrollments}</div>
                                <div className="text-[11px] text-gray-500">Total Enrollments</div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div className="text-center p-3 bg-emerald-50 rounded-lg">
                                <div className="text-2xl font-bold text-emerald-600">{completedCount}</div>
                                <div className="text-[11px] text-gray-500">Completed</div>
                            </div>
                            <div className="text-center p-3 bg-amber-50 rounded-lg">
                                <div className="text-2xl font-bold text-amber-600">{inProgressCount}</div>
                                <div className="text-[11px] text-gray-500">In Progress</div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
